import { Navigate, Outlet, useLocation } from "react-router-dom";
import { isOnboardingFrontendEnabled } from "./featureFlags";
import useAuthBootstrap from "../../auth/useAuthBootstrap";
import { resolveAnonymousEntry } from "./anonymousEntry";
import { loadAnonymousOnboardingDraft } from "./onboardingDraftStore";

export function isOnboardingComplete(settings) {
  const onboarding = settings?.meta?.onboarding;
  if (onboarding) {
    return onboarding.isComplete === true || onboarding.status === "COMPLETED";
  }

  return settings?.meta?.hasTrainingProfile === true;
}

// The gate's decision as an element: a redirect, or null when the route may
// render. ExecutionShellGate applies the same decision to an authenticated
// TRAIN without adding a component layer around its subtree (§9.8).
export function useOnboardingGateRedirect() {
  const location = useLocation();
  const bootstrap = useAuthBootstrap();
  const enabled = isOnboardingFrontendEnabled();

  if (!enabled) {
    return null;
  }

  if (bootstrap.status === "anonymous") {
    const entry = resolveAnonymousEntry({ draft: loadAnonymousOnboardingDraft() });
    return <Navigate to={entry.destination} replace />;
  }

  if (!isOnboardingComplete({ meta: { onboarding: bootstrap.onboarding } })) {
    return (
      <Navigate
        to="/onboarding"
        replace
        state={{ from: `${location.pathname}${location.search}` }}
      />
    );
  }

  return null;
}

export default function OnboardingGate() {
  return useOnboardingGateRedirect() || <Outlet />;
}
